/**
 * Loading states for the clinic detail page — all delegate to the shared
 * loader components so every loader in the app looks the same.
 */
import ContentLoader from "../../../../../components/shared/ContentLoader";
import LoaderLoop from "../../../../../components/shared/loader/LoaderLoop";

/** Inline placeholder inside a line of text / a small cell. */
export function Block() {
  return <LoaderLoop size="xs" />;
}

export function KpiSkeleton() {
  return <ContentLoader size="sm" compact />;
}

export function CardSkeleton() {
  return (
    <div className="ncd2-card">
      <ContentLoader size="sm" />
    </div>
  );
}

export function PageSkeleton() {
  return (
    <div className="ncd2-page ncd2-page-loading" aria-busy="true">
      <ContentLoader fill message="טוען קליניקה…" />
    </div>
  );
}
